import React from 'react';
import { Calendar } from 'lucide-react';
import { Contract } from '../../../types/contract';
import { formatDate } from '../../../utils/dateUtils';
import { ComponentHeader } from './ComponentHeader';

interface EventDetailsCardProps {
  contract: Contract;
}

export const EventDetailsCard: React.FC<EventDetailsCardProps> = ({ contract }) => {
  return (
    <div className="bg-white shadow-lg border border-slate-200 rounded-lg overflow-hidden">
      <ComponentHeader
        title="Detalhes do Evento"
        subtitle={contract.nomeAniversariante}
        icon={Calendar}
      />
      <div className="p-2 space-y-1.5">
        <div className="flex items-center gap-2 text-xs">
          <span className="text-slate-500 w-16">Data:</span>
          <span className="font-medium">{contract.dataFesta ? formatDate(contract.dataFesta) : 'N/A'}</span>
        </div>
        <div className="flex items-center gap-2 text-xs">
          <span className="text-slate-500 w-16">Horário:</span>
          <span className="font-medium">{contract.horarioInicioFesta || 'N/A'}</span>
        </div>
        <div className="flex items-center gap-2 text-xs">
          <span className="text-slate-500 w-16">Convidados:</span>
          <span className="font-medium">{contract.numeroConvidados || 'N/A'}</span>
        </div>
        <div className="flex items-center gap-2 text-xs">
          <span className="text-slate-500 w-16">Recreação:</span>
          <span className="font-medium">
            {contract.inicioRecreacao && contract.fimRecreacao 
              ? `${contract.inicioRecreacao} - ${contract.fimRecreacao}` 
              : 'N/A'
            }
          </span>
        </div>
      </div>
    </div>
  );
};
